module.exports = webappBundle("configuration/audit-log.css");